// src/features/dashboard/DashboardPage.tsx
import {
  EmptyState,
  InlineFetchingIndicator,
  PageContainer,
  PageProgress,
} from '../../app/components/foundation';
import { VaniaGlassPanel } from '@vanialabs/ui-engine';
import { VaniaContentSkeleton, VaniaLoadingSystem } from '../../app/components/loading';
import { CommandCenterDashboard } from './components';
import { useDashboard } from './hooks/useDashboard';
import { useMonitoring } from '../monitoring/hooks/useMonitoring';
import './styles/dashboard.css';

/**
 * Super Admin Command Center. Data remains supplied by the existing
 * dashboard hook; this page owns only the presentation shell.
 */
export function DashboardPage() {
  const { dashboard, loading, error } = useDashboard();
  const monitoring = useMonitoring();

  return (
    <PageContainer className="vania-command-page">
      <div
        className="vania-async-content vania-dashboard-async"
        aria-busy={loading || undefined}
      >
        <PageProgress active={loading && !dashboard} />
        {loading && !dashboard ? <DashboardSkeleton /> : null}
        {loading && dashboard ? <InlineFetchingIndicator /> : null}
        {!loading && error ? <div className="vania-async-state vania-async-state-error" role="alert">{error}</div> : null}
        {!loading && !dashboard && !error ? <EmptyState message="داده‌ای برای نمایش وجود ندارد." /> : null}
        {dashboard ? <div className="vania-dashboard-wrapper"><CommandCenterDashboard dashboard={dashboard} monitoring={monitoring.monitoring} monitoringLoading={monitoring.loading} monitoringError={monitoring.error} /></div> : null}
      </div>
    </PageContainer>
  );
}

function DashboardSkeleton() {
  return (
    <VaniaLoadingSystem mode="route" className="vania-dashboard-loading-system" label="در حال آماده‌سازی داشبورد">
    <div className="vania-dashboard-wrapper vania-dashboard-loading" role="status" aria-label="در حال آماده‌سازی داشبورد">
      <section className="vania-command-surface">
        <div className="vania-command-content">
          <div className="vania-control-plane-metrics">
            {Array.from({ length: 4 }, (_, index) => (
              <VaniaGlassPanel key={`dashboard-metric-skeleton-${index}`}>
                <VaniaContentSkeleton style={{ width: '42%', height: '0.75rem' }} />
                <VaniaContentSkeleton style={{ width: '64%', height: '1.75rem' }} />
              </VaniaGlassPanel>
            ))}
          </div>
          <div className="vania-command-grid">
            <VaniaGlassPanel><VaniaContentSkeleton style={{ width: '28%', height: '0.9rem' }} /><VaniaContentSkeleton style={{ width: '100%', height: '15rem' }} /></VaniaGlassPanel>
            <VaniaGlassPanel><VaniaContentSkeleton style={{ width: '32%', height: '0.9rem' }} /><VaniaContentSkeleton style={{ width: '100%', height: '15rem' }} /></VaniaGlassPanel>
          </div>
          <div className="vania-command-bottom-grid">
            {Array.from({ length: 3 }, (_, index) => (
              <VaniaGlassPanel key={`dashboard-panel-skeleton-${index}`}>
                <VaniaContentSkeleton style={{ width: '38%', height: '0.9rem' }} />
                <VaniaContentSkeleton style={{ width: '100%', height: '8rem' }} />
              </VaniaGlassPanel>
            ))}
          </div>
        </div>
      </section>
    </div>
    </VaniaLoadingSystem>
  );
}
